import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { HeroSection } from '@/components/landing/hero-section'
import { ClientsMarquee } from '@/components/landing/clients-marquee'
import { StudioSection } from '@/components/landing/studio-section'
import { ServicesSection } from '@/components/landing/services-section'
import { WorkSection } from '@/components/landing/work-section'
import { TestimonialSection } from '@/components/landing/testimonial-section'
import { ProcessSection } from '@/components/landing/process-section'
import { ContactSection } from '@/components/landing/contact-section'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo />

            <HeroSection />
            <ClientsMarquee />
            <StudioSection />
            <ServicesSection />
            <WorkSection />
            <TestimonialSection />
            <ProcessSection />
            <ContactSection />
        </Layout>
    )
}

export default Home
